import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import resendVerificationEmail from '@/api/auth/resendVerificationEmail.endpoint';
import StatusCodes from '@/v2/constants/StatusCodes';

export default function useResendVerificationEmailMutation() {
  return useMutation({
    mutationFn: () => resendVerificationEmail(),
    meta: {
      notification: {
        success: 'We sent you a new verification email.',
        error: getResendErrorMessage,
      },
    },
  });
}

function getResendErrorMessage(error: AxiosError) {
  if (error.response?.status == StatusCodes.TOO_MANY_REQUESTS) {
    return false;
  }

  return "We couldn't send the email. Please try again.";
}
